import {
  CAROUSEL_AUTOMODE_STOP,
  CAROUSEL_AUTOMODE_START,
  CAROUSEL_AUTOMODE_TOGGLE,
  CAROUSEL_MANUALMODE_TOGGLE,
  CAROUSEL_MANUALMODE_START,
  CAROUSEL_MANUALMODE_STOP,
  CAROUSEL_INDEX_CHANGE,
  CAROUSEL_CONTENT_CHANGE,
  CAROUSEL_CONTENT_NAME_SET,
  PHASE_CHANGE_ON_ACTIVE_CHANNEL
} from './actionTypes'

export const toggleCarouselManualmode = () => ({
    type: CAROUSEL_MANUALMODE_TOGGLE
})

export const startCarouselManualmode = () => ({
    type: CAROUSEL_MANUALMODE_START
})

export const stopCarouselManualmode = () => ({
    type: CAROUSEL_MANUALMODE_STOP
})

export const toggleCarouselAutomode = () => ({
    type: CAROUSEL_AUTOMODE_TOGGLE
})

export const startCarouselAutomode = () => ({
    type: CAROUSEL_AUTOMODE_START
})

export const stopCarouselAutomode = () => ({
    type: CAROUSEL_AUTOMODE_STOP
})

export const changeCarouselIndex = ( index: number ) => ({
    type: CAROUSEL_INDEX_CHANGE,
    value: index
})

export const changeCarouselContent = ( values: any ) => ({
    type: CAROUSEL_CONTENT_CHANGE,
    values: values
})

export const setCarouselContentName = ( names: any ) => ({
    type: CAROUSEL_CONTENT_NAME_SET,
    values: names
})

export const carouselHandler = ( payload: any ) => ({
    type: PHASE_CHANGE_ON_ACTIVE_CHANNEL,
    value: payload
})
